// @ts-check
import { Trans } from '@lingui/macro';
import { View } from '@react-pdf/renderer';
import React from 'react';
import CloudinaryImage from '../../components/CloudinaryImage';
import Page from '../../components/Page';
import type { Collection } from './MyList';
import { Text, Title } from './Text';

export default function CoverPage({
  collection,
  style,
  bleed = 0,
  user,
  ...rest
}: {
  collection: Collection;
  style?: any;
  user: any;
  bleed?: number;
}) {
  return (
    <Page
      size="A4"
      style={[
        { paddingVertical: `${bleed}mm`, paddingHorizontal: `${bleed}mm` },
        style,
      ]}
      {...rest}
    >
      <View style={{ alignItems: 'center', paddingTop: '5cm' }}>
        <CloudinaryImage
          src={collection.logo.fixed.src}
          width={200}
          height={200}
          trim
          style={{ marginBottom: 20 }}
        />
        <Title variant="bold" style={{ fontSize: 18, marginBottom: 10 }}>
          {collection.name}
        </Title>
        <Text style={{ marginBottom: 3 }}>
          <Trans>Tasting list for</Trans>
        </Text>
        <Text>{user?.displayName}</Text>
      </View>
    </Page>
  );
}
